import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box
} from "@mui/material";
import { useTranslation } from "react-i18next";

const ConfirmDialog = ({ open, onClose, onConfirm, title, message }) => {
    const { t } = useTranslation();

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle sx={{ color: "#000", fontWeight: 600 }}>
                {title || t("confirmDialog.title")}
            </DialogTitle>
            <DialogContent>
                <Typography sx={{ color: "#000" }}>
                    {message || t("confirmDialog.message")}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={onClose} sx={{ color: "#000" }}>
                    {t("actions.cancel")}
                </Button>
                <Button
                    onClick={onConfirm}
                    variant="contained"
                    sx={{
                        bgcolor: "#d32f2f",
                        color: "#fff",
                        fontWeight: 500,
                        "&:hover": {
                            bgcolor: "#b71c1c",
                        },
                    }}
                >
                    {t("actions.confirm")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;
